var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriveLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 305,
    height: 125,
    viewBox: "0 0 305 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "5gb80897ua",
    width: "108.4%",
    height: "122.4%",
    x: "-4.2%",
    y: "-11.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#5gb80897ua)",
    transform: "translate(-847 -150) translate(856 159)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M159 32c0 2.204-1.796 4-4 4-2.204 0-4-1.796-4-4 0-2.204 1.796-4 4-4 2.228 0 4 1.796 4 4zM159 45.83v55.34c0 2.11-1.796 3.83-4 3.83-2.204 0-4-1.72-4-3.83V45.83c0-2.11 1.796-3.83 4-3.83 2.228 0 4 1.72 4 3.83zM177.918 44c1.64 0 3.121 1.027 3.668 2.545l18.615 51.02h.251l18.456-51.176c.524-1.429 1.891-2.389 3.44-2.389 2.552 0 4.307 2.5 3.418 4.823l-20.028 52.448c-.866 2.233-3.053 3.729-5.49 3.729-2.416 0-4.604-1.451-5.47-3.684L174.273 49.18c-1.002-2.478.889-5.18 3.646-5.18zM278.013 62.03c-.927-2.637-2.216-4.957-3.889-6.985-1.673-2.028-3.708-3.65-6.105-4.889-2.397-1.24-5.11-1.848-8.14-1.848-3.12 0-5.856.609-8.253 1.848-2.397 1.24-4.432 2.861-6.105 4.89-1.673 2.027-3.007 4.37-4.002 7.029-.859 2.298-1.47 4.64-1.831 7.006-.09.609.407 1.172 1.017 1.172h37.534c.724 0 1.266-.608 1.221-1.33-.203-2.365-.678-4.663-1.447-6.894zM240.66 84.987c.746 2.906 1.967 5.497 3.64 7.818 1.673 2.298 3.799 4.213 6.354 5.723 2.555 1.51 5.63 2.275 9.225 2.275 5.517 0 9.813-1.442 12.934-4.303 2.577-2.366 4.5-5.385 5.765-9.057.498-1.442 1.9-2.389 3.415-2.389 2.487 0 4.273 2.456 3.436 4.8-1.695 4.73-4.16 8.516-7.393 11.422-4.274 3.808-10.31 5.723-18.134 5.723-4.862 0-9.09-.856-12.64-2.568-3.55-1.713-6.444-4.056-8.682-7.03-2.239-2.974-3.89-6.444-4.975-10.386-1.085-3.943-1.605-8.089-1.605-12.46 0-4.055.543-8.043 1.605-11.94 1.086-3.898 2.736-7.368 4.975-10.432 2.238-3.064 5.132-5.52 8.682-7.39 3.55-1.87 7.756-2.794 12.64-2.794 4.952 0 9.18.991 12.684 2.974 3.505 1.983 6.377 4.596 8.57 7.818 2.193 3.222 3.776 6.917 4.726 11.085.565 2.478.95 5.002 1.108 7.525.18 2.794-2.013 5.182-4.817 5.182h-41.807c-.452 0-.814.36-.814.811.045 2.456.43 4.98 1.108 7.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A72BA",
    d: "M76.949 53.43c0 6.487-1.913 12.565-5.22 17.713L86.16 85C92.962 76.178 97 65.246 97 53.43 97 35.492 87.695 19.64 73.5 10L59 23.948c10.699 5.806 17.949 16.85 17.949 29.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5C029",
    d: "M19.93 19.605H20L0 0v83l19.93-19.513V19.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40B75F",
    d: "M71.121 70.979c-5.974 9.847-16.696 16.442-28.916 16.442-1.659 0-16.446-.023-22.76-.092V63L0 82.74V107h42.205C59.718 107 75.3 98.352 85 85.046L71.121 70.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E02834",
    d: "M42.306 19.584c6.08 0 11.772 1.625 16.713 4.416L73 9.952C64.302 3.798 53.714 0 42.306 0 41.122 0 3.53.023 3.165 0H0l19.582 19.676c6.376-.069 21.085-.092 22.724-.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4B627",
    d: "M30 26v53l35.212-24.977c1.05-.75 1.05-2.273 0-3.023L30 26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5C029",
    d: "M30 26v53l31.441-28.682c.818-.75.724-2.023-.187-2.636L30 26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M135.593 42c-5.465 0-13.742 3.325-19.505 10.112-.022-.204-.022-.294-.045-.294V46.66c0-1.923-1.578-3.484-3.522-3.484-1.943 0-3.521 1.561-3.521 3.484v54.562c0 2.081 1.715 3.778 3.819 3.778 2.103 0 3.818-1.697 3.818-3.778V66.567c2.012-12.713 14.108-17.826 18.956-17.826 1.875 0 3.407-1.516 3.407-3.37 0-1.855-1.532-3.371-3.407-3.371z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveLogo);
export default __webpack_public_path__ + "static/media/drive-logo.0d9891d0.svg";
export { ForwardRef as ReactComponent };